import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/';

@Injectable()
export class BrowserEventsService {

    public onWindowUnload(): Observable<any> {
         return Observable.fromEvent(document, 'onbeforeunload');
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/browser-events.service.ts